module.exports = __webpack_public_path__ + "static/media/youtube.664e7442.JPG";